@if (value) {
    <div class="dropdown-wrapper" appMousedownOutside (mousedownOutside)="el.hidden = true" appScrollToChild>
        <div class="select-component" (click)="el.hidden = !el.hidden">
            <div class="selected-list">
                <span class="square" [style.background]="value"></span>

                <label>{{ allColorsMap?.get('barColor')?.[value] }}</label>
            </div>

            <span class="icon-arrow-down"></span>
        </div>

        <div class="dropdown" #el [hidden]=true>
            <ul>
                @for (item of barColors; track item.value) {
                    <li (click)="onColorSelected(item, el)">
                        <span class="square" [style.background]="item.value"></span>

                        {{ item.label }}
                    </li>
                }
            </ul>
        </div>
    </div>
}
